// extracted by mini-css-extract-plugin
module.exports = {"idea":"home-idea__idea"};